export default __webpack_public_path__ + "7e0b54d6a62872df77ded9bfe424f471.svg";